import { Mui } from "@osu/react-ui";
import { isEmpty } from "../../util/functions";

const displayUnit = (value) => (isEmpty(value) ? "-" : value);

const roundDiff = (earned, min) => {
  if (isEmpty(earned)) return "-";
  const diff = Number(earned) - (isEmpty(min) ? 0 : Number(min));
  if (Number.isNaN(diff)) return "-";
  return Number.isInteger(diff) ? String(diff) : diff.toFixed(1);
};

const CollegePrep = (props) => {
  const { studentData } = props;
  const collegePrep = studentData?.data?.collegePrep;
  const minConfig = collegePrep?.minimumRequiredConfiguration;

  const hide = ["domestic-transfer", "international-transfer"].includes(studentData?.data?.demographics?.committeeId) && studentData?.data?.earnedHoursPU >= 30;

  return (
    <Mui.Box>
      <Mui.Table aria-label="simple table">
        <Mui.TableHead>
          <Mui.TableRow>
            <Mui.TableCell                role="columnheader" scope="col">Units</Mui.TableCell>
            <Mui.TableCell align="center" role="columnheader" scope="col">Math</Mui.TableCell>
            <Mui.TableCell align="center" role="columnheader" scope="col">Natural Science</Mui.TableCell>
            <Mui.TableCell align="center" role="columnheader" scope="col">Foreign Language</Mui.TableCell>
          </Mui.TableRow>
        </Mui.TableHead>
        <Mui.TableBody>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row">Minimum Required Units</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(minConfig?.math) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(minConfig?.naturalScience) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(minConfig?.foreignLanguage) : "-"}</Mui.TableCell>
          </Mui.TableRow>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row">Earned Units</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(collegePrep?.earnedMath) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(collegePrep?.earnedScience) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? displayUnit(collegePrep?.earnedForeign) : "-"}</Mui.TableCell>
          </Mui.TableRow>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row">Difference Between Minimum and Earned</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? roundDiff(collegePrep?.earnedMath, minConfig?.math) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? roundDiff(collegePrep?.earnedScience, minConfig?.naturalScience) : "-"}</Mui.TableCell>
            <Mui.TableCell align="center">{!hide ? roundDiff(collegePrep?.earnedForeign, minConfig?.foreignLanguage) : "-"}</Mui.TableCell>
          </Mui.TableRow>
        </Mui.TableBody>
      </Mui.Table>
    </Mui.Box>
  );
};
export default CollegePrep;
